export enum TableIdentifiers {
  DisasterRecoveries = "disasterRecoveries",
  TollFreeNumbers = "tollFreeNumbers",
}
